export { useFastshiftUIAnalytics } from "./use-fastshift-ui-analytics";
export { useFastshiftPageAnalytics } from "./use-fastshift-page-analytics";
export { useShouldShowConsentLandingPage } from "./use-should-show-consent-landing-page";
